export default "__VITE_ASSET__f4c571f6__"